import React from "react";

import Chip from "@mui/material/Chip";

import { PartnerMember } from "../../api/partners";

interface MemberBadgesProps {
  member: PartnerMember;
}

/**
 * Status chips shown next to a member's name — shared by the manage-members
 * dialog and the read-only roster so both surfaces describe the same member
 * the same way.
 */
export const MemberBadges: React.FC<MemberBadgesProps> = ({ member }) => (
  <>
    {member.isStaff && <Chip label="Staff" size="small" variant="outlined" />}
    {member.portalAccess === true && (
      <Chip label="Partners" size="small" color="primary" variant="outlined" />
    )}
    {member.entitlementSkippedAt && (
      <Chip label="Own subscription" size="small" variant="outlined" />
    )}
  </>
);
